import { Text } from '@leverege/ui-elements';
import React from 'react';
import { connect } from 'react-redux';
import { Attributes } from '@leverege/ui-attributes';
import P from '@leverege/promise';
import { Blocker } from '@leverege/molten/views';
import { ParentUtil, ItemDelegate } from '@leverege/molten/imagine';
import { jsx as _jsx } from "react/jsx-runtime";
class BillLocationAddressRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.initialLoad = P.deferred();
  }
  componentDidMount() {
    this._isMounted = true;
    const {
      dispatch,
      original,
      parentAction,
      attribute
    } = this.props;
    const locationId = attribute.get(original.data);
    if (locationId) {
      dispatch(parentAction.item(locationId).get({
        ttl: 300000
      })).then(() => {
        if (this._isMounted) {
          this.initialLoad.resolve();
        }
      });
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  renderChildren = () => {
    const {
      item
    } = this.props;
    if (!item?.data?.streetAddress) {
      return null;
    }
    return /*#__PURE__*/_jsx(Text, {
      variant: "columnValue",
      children: item.data.streetAddress
    });
  };
  render() {
    const matchContext = {
      client: 'BillLocationAddressRenderer'
    };
    return /*#__PURE__*/_jsx(Blocker, {
      matchContext: matchContext,
      context: this.props,
      hooks: [{
        execute: () => this.initialLoad
      }],
      render: this.renderChildren,
      small: true,
      loadingProps: {
        inline: true
      }
    });
  }
}
export default connect((state, props) => {
  const {
    original
  } = props;
  const attr = Attributes.getAttribute('bill.location', 'bill');
  const parentAction = ParentUtil.getParentAction(original, attr);
  const value = attr.get(original.data);
  return {
    parentAction,
    attribute: attr,
    item: ItemDelegate.getItem(value),
    parentItems: parentAction.getList(state),
    loading: parentAction.isLoading(state),
    currentLoading: parentAction.isLoading(state),
    allowed: parentAction.canList(state, true)
  };
})(BillLocationAddressRenderer);